import { IPromise, IScope } from 'angular';
import { IFontStyleModel } from '../../tn.common';
import { UserService } from '../../tn.user/service.tn.user';
import {
    IFavoriteList,
    INewFavoriteList,
} from '../favorites-repository.service/favoritesRepository';
import { LocalFavorites } from '../local-favorites.service/localFavorites';
import template from './save-favorite-popover-add.html';

export class SaveFavoritePopoverAddController {
    // binding: called after saving a list.
    onSaved?: (args: { list: IFavoriteList }) => void;
    // binding: styles to add to the list.
    selectedStyles: IFontStyleModel[] = [];

    favorites: IFavoriteList[] = this.localFavorites.favorites$.getValue();
    // initialize to most recent favorite or -1 to create a new list
    selectedFavorite = this.favorites?.slice(-1).pop()?.id ?? -1;
    // name for new lists.
    name = '';

    static $inject = ['localFavorites', 'tn.user.service', '$scope'];
    constructor(
        protected localFavorites: LocalFavorites,
        protected userService: UserService,
        protected $scope: IScope
    ) {
        localFavorites.favorites$.subscribe((favorites) => {
            // update to most recent favorite if favs update.
            this.selectedFavorite = favorites?.slice(-1).pop()?.id ?? -1;
            this.favorites = favorites;
        });
    }

    onNewListSelected(): void {
        // for some reason form.input.focus() doesn't work here in the template.
        const id = `${this.$scope.$id}_list_new_name`;
        document.getElementById(id)?.focus();
    }

    addToFavorite(): IPromise<void> | void {
        if (this.selectedFavorite === -1) {
            if (!this.name) {
                // TODO: form validatin before submit.
                return;
            }
            const list: INewFavoriteList = {
                style: this.selectedStyles,
                name: this.name,
            };
            return this.localFavorites.saveFavoriteList(list).then((list) => {
                // reset the name field.
                this.name = '';
                this.onSaved && this.onSaved({ list });
            });
        }

        const list =
            this.favorites &&
            this.favorites.find((fav) => fav.id === this.selectedFavorite);
        if (!list) {
            // TODO: form validation before submit to prevent this from ever happending.
            throw new Error(`List not found for id ${this.selectedFavorite}`);
        }

        // merge and dedulicate styles.
        const styleIdx = [...list.style, ...this.selectedStyles].reduce(
            (acc, style) => {
                acc[style.id] = style;
                return acc;
            },
            {}
        );
        // update list.
        list.style = Object.values(styleIdx);

        return this.localFavorites.saveFavoriteList(list).then((list) => {
            this.onSaved && this.onSaved({ list });
        });
    }
}

export const SaveFavoritePopoverAddComponent = {
    controller: SaveFavoritePopoverAddController,
    template,
    bindings: {
        onSaved: '&',
        selectedStyles: '<',
    },
};
